import React from "react";
import { ItemAttribute } from "../../types/types";
import { useSaleItemAttributes } from "./useSaleItemAttributes";
import styles from "./SaleItemAttributes.module.scss";
import { shortenText } from "../../utils/functions/shortenText";

type Props = {
  view?: boolean;
  attributes?: ItemAttribute[];
  small?: boolean;
};

export const SaleItemAttributes = ({ attributes, view, small }: Props) => {
  const { sortRequiredFirst, formatAttributeValue } = useSaleItemAttributes();

  if (!attributes || attributes.length === 0) {
    return <div className={view ? styles.containerView : styles.container} />;
  }

  const sorted = [...attributes].sort(sortRequiredFirst);
  const display = view ? sorted : sorted.slice(0, 2);

  return (
    <div className={view ? styles.containerView : styles.container}>
      <div className={styles.topContainer}>
        {view && <span className={styles.more}>Атрибуты</span>}
        <div className={styles.row}>
          {display.map((el) => (
            <div key={el.id} className={styles.attribute}>
              <span
                className={
                  small ? styles.attributeTextSmall : styles.attributeText
                }
              >
                {el.name}:{" "}
              </span>
              <span className={styles.value}>
                <span className={styles.attributeText}>
                  {view
                    ? formatAttributeValue(el)
                    : shortenText(formatAttributeValue(el), 10)}
                </span>
              </span>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};
